/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadQueryCloudAccount extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("WorkloadQueryCloudAccount");
    }

    getFixupPrototypeFunction() { return WorkloadQueryCloudAccount.fixupPrototype; }

    static newInstance(model: Partial<WorkloadQueryCloudAccount>): WorkloadQueryCloudAccount {
        let obj = Object.assign(new WorkloadQueryCloudAccount(), model);
        WorkloadQueryCloudAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadQueryCloudAccount>): WorkloadQueryCloudAccount {
        if (!model) return null;
        return WorkloadQueryCloudAccount.newInstance(<WorkloadQueryCloudAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadQueryCloudAccount) {
        if (!obj) return;

        models.WorkloadQueryCloudAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadQueryCloudAccount): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkloadQueryCloudAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of cloud accounts
     */
    cloud_account_ids: Array<string>;

}
